/**
 * FinancialsSynthesisPrint — page « Synthèse » des états financiers.
 * Réutilise le COMPOSANT RÉEL de l'écran (FinancialsSynthesisSimple) : la card
 * « Positions clés au Bilan » (via `liquidityHeader`) puis les deux tableaux
 * « Compte de résultat simplifié » et « Cash flow opérationnel » (mois en cours ·
 * cumulé · cumulé N-1 · variation). Unité = hub États financiers.
 * `onReady` (one-shot) signale au host que les données sont chargées.
 */
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import FinancialsSynthesisSimple from '../FinancialsSynthesisSimple';
import { usePersistentValue } from '../../hooks/usePersistentState';
import { p } from '../../i18n/useP';
import PrintReportHeader from '../hr/print/PrintReportHeader';
import '../hr/print/PeoplePrint.css';
import './financialsScreenPrint.css';

export default function FinancialsSynthesisPrint({ activeTenant, year, editedAt, onDataReady, cutoff = null }) {
  const { t } = useTranslation();
  const tenantId = activeTenant?.id;
  const [unit] = usePersistentValue(`fin_reports_unit_${tenantId}`, 'kchf');
  const done = useRef(false);
  const ready = () => { if (!done.current) { done.current = true; if (onDataReady) onDataReady('financials-synthesis'); } };

  return (
    <section className="ppl-print__section ppl-print__section--wide fin-screenprint">
      <PrintReportHeader category={p('Rapport financier')} title={t('phrases:p_ab761b3579')} year={year} unit={unit} tenant={activeTenant} editedAt={editedAt} />
      <FinancialsSynthesisSimple liquidityHeader cutoff={cutoff} activeTenant={activeTenant} year={year} unit={unit} onReady={ready} />
    </section>
  );
}
